var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart_content"}},_vm._l((_vm.rpList),function(rp,idx){return _c('div',{key:rp.id},[_c('VBarItem',{attrs:{"data":rp,"index":idx}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }